var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrompt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16632 4.99793C9.6269 4.53786 10.3731 4.53786 10.8337 4.99793C10.3736 4.53735 10.3736 3.79115 10.8337 3.33057C10.3731 3.79063 9.6269 3.79063 9.16632 3.33057C9.62639 3.79115 9.62639 4.53735 9.16632 4.99793Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0021 4.99793C15.4627 4.53786 16.2089 4.53786 16.6694 4.99793C16.2094 4.53735 16.2094 3.79115 16.6694 3.33057C16.2089 3.79063 15.4627 3.79063 15.0021 3.33057C15.4621 3.79115 15.4621 4.53735 15.0021 4.99793Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0005 8.23093C10.4888 7.74257 11.2806 7.74257 11.769 8.23093V8.23093C12.2573 8.71929 12.2573 9.51108 11.769 9.99943L5.46601 16.3024C4.97765 16.7907 4.18587 16.7907 3.69751 16.3024V16.3024C3.20915 15.814 3.20915 15.0222 3.69751 14.5339L10.0005 8.23093Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0021 10.8337C15.4627 10.3737 16.2089 10.3737 16.6694 10.8337C16.2094 10.3732 16.2094 9.62696 16.6694 9.16638C16.2089 9.62645 15.4627 9.62645 15.0021 9.16638C15.4621 9.62696 15.4621 10.3732 15.0021 10.8337Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrompt);
export default ForwardRef;